<template>
  <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
    <v-container :class="$vuetify.breakpoint.xsOnly ? '' : 'elevation-2'">
      <v-text-field
        :label="labels.numero_asignatura"
        v-model="form.numero"
        :error-messages="errors.numero"
        :rules="[rules.required('numero_asignatura')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        :label="labels.clave_asignatura"
        v-model="form.clave"
        :error-messages="errors.clave"
        :rules="[rules.required('clave_asignatura')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        :label="labels.nombre_asignatura"
        v-model="form.nombre"
        :error-messages="errors.nombre"
        :rules="[rules.required('nombre_asignatura')]"
        :disabled="loading"
      ></v-text-field>

      <v-select
        :label="labels.tipo_asignatura"
        v-model="form.tipo_asignatura_id"
        :error-messages="errors.tipo"
        :rules="[rules.required('tipo_asignatura')]"
        :disabled="loading"
        :items="tipoAsignatura"
        item-text="nombre"
        item-value="id"
        dense
      ></v-select>

      <v-text-field
        :label="labels.creditos_asignatura"
        v-model="form.creditos"
        :error-messages="errors.creditos"
        :rules="[rules.required('creditos_asignatura')]"
        :disabled="loading"
      ></v-text-field>
    </v-container>

    <v-layout justify-end mt-2>
      <v-btn
        flat
        :disabled="loading"
        @click="$router.go(-1)"
        color="grey darken-2"
      >
        Cancelar
      </v-btn>

      <v-btn
        type="submit"
        :disabled="loading"
        color="primary"
      >
        Guardar
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      form: {
        numero: null,
        clave: null,
        nombre: null,
      },

      tipoAsignatura: []
    }),

    computed: {
      ...mapGetters({
        live_mode: "auth/live_mode",
      })
    },

    watch: {
      live_mode(val) {
        if (val !== undefined) {
          this.$router.push({ name: 'programa' })
        }
      }
    },

    mounted() {
      this.getCatalogoTipoAsignatura()
    },

    methods: {
      getCatalogoTipoAsignatura() {
        axios
          .get(api.path('catalogos.tipo_asignatura'))
          .then(res => {
            this.tipoAsignatura = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getAsignaturas() {
        this.loading = true
        axios
          .get(api.path('programas.asignaturas', { id: this.$route.params.id } ))
          .then(res => {
              this.asignaturas = res.data
              this.pagination.rowsPerPage = res.data.total
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {
            this.loading = false
          })
      },
      
      submit() {
        if (this.$refs.form.validate()) {
          this.loading = true

          axios.post(api.path('programas.asignaturas', { id: this.$route.params.id }), this.form)
            .then(res => {
              this.$toast.success('Asignatura agregada correctamente.')
              this.$emit('success', res.data)
            })
            .catch(err => {
              this.handleErrors(err.response.data.errors)
            })
            .then(() => {
              this.loading = false
            })
        }
      }
    }
  }
</script>
